import $http from '../services/AxiosInstance';
import { ILanguage } from '../types/languages.type';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class LanguagesRepository {
  static async getlanguages(params: Params = {}) {
    try {
      let url = `/languages`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createLanguage(data: ILanguage): Promise<ILanguage> {
    try {
      const response = await $http.post('/languages', data);

      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateLanguage(data: ILanguage): Promise<ILanguage> {
    try {
      const response = await $http.patch(`/languages/${data.id}`, data);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
  static async deleteLanguage(id: number): Promise<number> {
    try {
      const response = await $http.delete(`/languages/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async restoreLanguage(id: number): Promise<number> {
    try {
      const response = await $http.post(`/languages/restore/${id}`);
      return response.status;
    } catch (error) {
      throw Error;
    }
  }
  static async getLanguageByUrlDomain(urlDomain: string): Promise<string> {
    try {
      const {data} = await $http.get(`/languages/by-url-domain?urlDomain=${urlDomain}`);

      return data.lang;
    } catch (error) {
      throw Error;
    }
  }
}

export default LanguagesRepository;
